import { useRecoilValue } from 'recoil'
import useDebounce from 'shared/hooks/useDebounce'
import { useCallback, useEffect } from 'react'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import gradeTableFields from './gradeTable.fields'
import { ITeamDefence } from 'screens/Protection/protection.types'
import protectionsApi from 'screens/Protection/protection.api'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import myTeamTableAtom from './grade.atom'

const GradeTable = () => {
  const state = useRecoilValue(myTeamTableAtom)
  const debouncedSearch = useDebounce(state.filters.search, 400)
  const navigate = useNavigate()
  const queryParams = useParams()

  const defenceId = queryParams.id

  useEffect(() => {
    itemsSetter([])
  }, [defenceId])

  const fetcher = useCallback(
    (params: Record<string, any>) => {
      return protectionsApi.getMyTeamResult({
        defenceId: queryParams?.id,
        ...params,
      })
    },
    [debouncedSearch, state.filters, queryParams?.id]
  )

  const itemsSetter = useItemsSetter(myTeamTableAtom)

  const tableCtrl = useTableWithRequest<ITeamDefence>({
    dataFetcher: fetcher,
    fields: gradeTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: `grade-${queryParams?.id}`,
    resetKey: defenceId,
  })

  const handleClick = (team: ITeamDefence) => {
    navigate(`/protection-schedule/${queryParams?.id}/${team?.teamId}`)
  }

  return (
    <Table
      {...tableCtrl}
      items={tableCtrl.orderedItems}
      handleSelect={tableCtrl.selectedCtrl.setSelected}
      selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof ITeamDefence>}
      handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
      onCLick={handleClick}
      itemKey='id'
    />
  )
}

export default GradeTable
